import React from "react";
import animation from '../../Assets/lottie/page.json';
import LottieAnimation from "../Animation/LottieAnimation";
import "./Loading.scss";

const Loading = (props) => {

    const { title, content } = props;

    return (
        <div className="loadingScreen">
            <div className="icon">
                <LottieAnimation animationData={animation} />
            </div>
            { title && content && <div className="text">
                <h3>{title}</h3>
                <p>{content}</p>
            </div> }
        </div>
    );
};

export default Loading;